import type { Competitor } from "@/services/competitor_monitoring";

export const competitorLimitMessage =
  "You have reached the maximum number of competitors";

/**
 * Returns a formatted error message for a competitor's Instagram and Facebook errors.
 * Returns null if the competitor has no errors.
 * Uses <br> for line breaks to support HTML tooltips.
 */
export function getCompetitorErrorMessage(
  competitor: Competitor | null | undefined,
): string | null {
  if (!competitor) {
    return null;
  }
  const errors: string[] = [];
  if (competitor.instagramError) {
    errors.push(`Instagram: ${competitor.instagramError}`);
  }
  if (competitor.facebookError) {
    errors.push(`Facebook: ${competitor.facebookError}`);
  }
  return errors.length > 0 ? errors.join("<br>") : null;
}

export function compareCompetitorNames(
  a: Pick<Competitor, "name">,
  b: Pick<Competitor, "name">,
) {
  return a.name.localeCompare(b.name, undefined, {
    sensitivity: "base",
    numeric: true,
  });
}
